export  const initialStateCardVideoTutoriales = {
    cardVideoTutoriales: {
        loading: false,
        error: false,
        data: false
    }
}